import { ObjectType } from "myzod/libs/types";
import { FormikErrors } from "formik";
import { ValidationError } from "myzod";
import { getErrorObject } from "../../../utils/form.utils";

/**
 *
 * @param values Values to validate
 * @param schema Myzod object schema. collectErrors will be called.
 * @return {FormikErrors} Object where key is the property name and value is error message. May be nested.
 */
export function validateWithSchema<T extends Record<string, any>>(
  values: T,
  schema: ObjectType<T>
): FormikErrors<T> {
  const result = schema.collectErrors().try(values);

  if (result instanceof ValidationError && result.collectedErrors) {
    return getErrorObject(result.collectedErrors) as FormikErrors<T>;
  } else return {};
}
